<script>
  import { layoutMethods} from "@/state/helpers";
  import peddlrWallet from "@/views/pages/profileInformation/wallet/peddlrWallet";
  import eLoad from "@/views/pages/profileInformation/wallet/eLoad";
  import eRenta from "@/views/pages/profileInformation/wallet/eRenta";
  import billsPayment from "@/views/pages/profileInformation/wallet/billsPayment";

  /**
   * Profile Information Wallet component
   */
  export default {
    page: {
      title: "Profile Information Wallet"
    },
    components: {
      peddlrWallet,
      eLoad,
      eRenta,
      billsPayment,
    },
    computed: {
    },
    data() {
      return {
        title     : "Profile Information Wallet",
        businessId: 0,
        infoType  : null,
        walletType: null,
        currentView: "peddlrWallet"
      };
    },
    methods: {
      ...layoutMethods,
    },
    async mounted(){
      this.businessId = this.$route.params.bid
      this.infoType = this.$route.params.tab;
      this.walletType = this.$route.params.wallet;
      switch (this.walletType) {
        case "e-renta":
          this.title = 'E-Renta Transaction';
          this.currentView = "eRenta";
          break;
        case "e-load":
          this.title = 'E-Load Transaction';
          this.currentView = "eLoad";
          break;
        case "bills-payment":
          this.title = 'Bills Payment Transaction';
          this.currentView = "billsPayment";
          break;
        case "peddlr-wallet":
          this.title = 'Peddlr Wallet Transaction';
          this.currentView = "peddlrWallet";
          break;
        default:
          break;
      }
      this.changeTitle({title: this.title});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Merchant List', to: { name: 'Subscriber'} },
          { text: 'Merchant Details', to: { name: 'Profile Information', params: { tab: this.infoType, bid: this.businessId}} },
          { text: this.title, to: { name: 'Profile Information Wallet', params: { tab: this.infoType, bid: this.businessId, wallet: this.walletType}} }
        ]
      });
      
    }
  }
    
</script>


<template>
  <div class="row"><!-- outer div-->
    <component v-bind:is="currentView"></component>
  </div> <!-- end of outer div-->
</template>


<style>
</style>